/**
 * Improve Tips
 * Slider component that displays unfinished questions
 */
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';
import NullStateDiv from '@components/NullStateDiv';
import TipCard from '@components/TipCard';

import { useModal } from '@hooks/useModal';

import { DashHeader } from '../Common.style';
import { CardWrapper, ImproveTipsWrapper, Scroller } from './ImproveTips.style';

const messages = defineMessages({
  improveProfile: {
    id: 'improveTips.improveProfile',
    defaultMessage: 'Help Us Get to Know You',
  },
  noImprovements: {
    id: 'improveTips.noImprovements',
    defaultMessage: 'No improvements are recommended. Great work!',
  },
});

/** */
const ImproveTips: React.FC = () => {
  const { formatMessage } = useIntl();
  const { openModal } = useModal();

  // Get status of questions
  const tips: { text: string; setID: number }[] = [];

  // Open modal
  const handleOpenModal = (step: number) => {
    const content = `TipCard step ${step}`;
    openModal({
      children: content,
      width: 600,
    });
  };

  return (
    <ImproveTipsWrapper>
      <DashHeader>{formatMessage(messages.improveProfile)}</DashHeader>
      <ContentLoader loading={false}>
        {tips.length > 0 ? (
          <Scroller>
            {tips.map(({ text, setID }, index) => (
              <CardWrapper key={`fitness-card-${text}-${index}`}>
                <TipCard
                  index={index}
                  numTips={tips.length}
                  onClick={() => handleOpenModal(setID / 1000)}
                  tip={text}
                />
              </CardWrapper>
            ))}
          </Scroller>
        ) : (
          <NullStateDiv>{formatMessage(messages.noImprovements)}</NullStateDiv>
        )}
      </ContentLoader>
    </ImproveTipsWrapper>
  );
};

export default ImproveTips;
